{
  "valid": "有効"
}
